const { MinimogThemeStyles, MinimogThemeScripts } = window;

class QuickView {
  constructor() {
    this.modal = new MinimogTheme.Modal();
    this.isOpen = false;
    this.isLoading = false;

    // Event delegation for quick view button
    addEventDelegate({
      selector: ".m-product-quickview-button",
      handler: (e, target) => {
        e.preventDefault();
        if (this.isLoading) return;
        this.target = target;
        this.toggleLoading(true);
        const productHandle = target.dataset.productHandle;
        if (productHandle) this.loadProductQuickView(productHandle);
      },
    });

    // Subscribe to cart update events
    window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, () => {
      if (this.modal) this.close();
    });
  }

  // Load product quick view HTML
  loadProductQuickView(productHandle) {
    if (this.isOpen) {
      this.close(); // Close any existing modal before loading a new one
    }
    this.isLoading = true;

    this.loadAssets([MinimogThemeStyles.product, MinimogThemeStyles.productInventory], "quick-view-assets")
      .then(() =>
        fetchSection("product-quickview", { url: `${window.MinimogSettings.base_url}products/${productHandle}` })
      )
      .then((html) => {
        this.modalContent = html.querySelector(".m-product-quickview");
        const firstModel = html.querySelector("product-model");
        this.mediaGallery = this.modalContent.querySelector("media-gallery");

        return this.loadAssets(
          [MinimogThemeScripts.productMedia, MinimogThemeScripts.variantsPicker, MinimogThemeScripts.productInventory],
          "variants-picker"
        ).then(() => {
          const colorScheme = this.modalContent.dataset.colorScheme;
          this.modal.appendChild(this.modalContent);
          this.modal.setWidth("960px");
          this.modal.open();
          this.modal.setSizes(`m-gradient ${colorScheme}`);
          this.setupAmazonLink();
          this.toggleLoading(false);
          this.isOpen = true;
          this.isLoading = false; // Reset loading state

          if (firstModel) {
            return this.loadAssets(
              [
                MinimogThemeScripts.productModel,
                "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css",
              ],
              "product-model-assets"
            );
          }
        });
      })
      .then(() => {
        document.dispatchEvent(
          new CustomEvent("quick-view:loaded", {
            detail: { productUrl: this.target.dataset.productHandle },
          })
        );
      })
      .catch((error) => {
        console.error("Error loading product quick view:", error);
        this.toggleLoading(false);
      });
  }

  setupAmazonLink() {
    if (this.amazonVariantChangeHandler) {
      document.removeEventListener("variant:changed", this.amazonVariantChangeHandler);
      this.amazonVariantChangeHandler = null;
    }

    const mapElement = this.modalContent && this.modalContent.querySelector("[data-amazon-variant-map]");
    if (!mapElement) return;

    try {
      const variantMap = JSON.parse(mapElement.textContent);
      const updateAmazonLink = (variantId) => {
        if (!variantId) return;
        const amazonUrl = variantMap[String(variantId)];
        if (amazonUrl) {
          const links = this.modalContent.querySelectorAll(".yp-amazon-target-link, .yp-amazon-inline-btn, .yp-amazon-card__link");
          links.forEach((l) => { l.href = amazonUrl; });
        }
      };

      const selectedVariant = this.modalContent.querySelector('[name="id"]');
      if (selectedVariant && selectedVariant.value) updateAmazonLink(selectedVariant.value);

      this.amazonVariantChangeHandler = (event) => {
        const variantId = event.detail && event.detail.variant && event.detail.variant.id;
        updateAmazonLink(variantId);
      };
      document.addEventListener("variant:changed", this.amazonVariantChangeHandler);

      this.modalContent.addEventListener("change", (e) => {
        if (e.target && e.target.name === "id") {
          updateAmazonLink(e.target.value);
        }
      });
    } catch (error) {
      console.error("Unable to initialize the Amazon product link:", error);
    }
  }

  // Load assets helper function
  loadAssets(assets, key) {
    return new Promise((resolve, reject) => {
      loadAssetsNew(assets, key, resolve, reject);
    });
  }

  // Close the quick view modal
  close(e) {
    if (this.amazonVariantChangeHandler) {
      document.removeEventListener("variant:changed", this.amazonVariantChangeHandler);
      this.amazonVariantChangeHandler = null;
    }
    this.modal.close(e);
    this.isOpen = false;
  }

  // Toggle loading spinner on the target element
  toggleLoading(isLoading) {
    if (isLoading) {
      this.target.classList.add("m-spinner-loading");
    } else {
      this.target.classList.remove("m-spinner-loading");
    }
  }
}

// Initialize the QuickView instance
MinimogTheme.ProductQuickView = new QuickView();
